export const calcVolume = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcVolume(shipmentMethod, x)).reduce((a, b) => a + b, 0);

  return (item.width * item.height * item.depth) / 1728;
};

export const calcFreightCarge = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcFreightCarge(shipmentMethod, x)).reduce((a, b) => a + b, 0);

  if (shipmentMethod === "air") {
    if (!item.invoiceTotal && !item.weight) return 0;
    return 25 + Math.ceil(Math.min(Math.max(item.weight - 1, 0), 18)) * 4.95 + Math.ceil(Math.min(Math.max(item.weight - 19, 0), 30)) * 3.95 + Math.ceil(Math.max(item.weight - 49, 0)) * 2.95;
  }

  if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  const v = calcVolume(shipmentMethod, item);

  if (v < 1.01) return 15;
  if (v < 2.01) return 25;
  if (v < 5.01) return 35;
  if (v < 8.01) return 45;
  if (v < 10.01) return 55;
  if (v < 15.01) return 75;
  if (v < 20.01) return 100;
  return 100 + 5 * (v - 20);
};

export const calcInsurance = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcInsurance(shipmentMethod, x)).reduce((a, b) => a + b, 0);
  if (Array.isArray(item)) {
    const total = item.map((x) => x.invoiceTotal).reduce((a, b) => a + b, 0);
    return Math.max(0.02 * total, 5);
  }
  if (shipmentMethod === "air") return 0;
  if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;

  const rate = 0.84;
  const volume = calcVolume(shipmentMethod, item);
  if (volume <= 1) return 0;
  return Math.max(0.02 * item.invoiceTotal, 5) * rate;
};

export const calcPortFee = (shipmentMethod, item) => {
  if (shipmentMethod === "air") return 0;
  if (Array.isArray(item)) {
    const totalVolume = calcVolume(shipmentMethod, item);
    if (totalVolume === 0) return 0;
    return Math.max(1.5 * totalVolume, 8.4);
  }
  if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  const v = calcVolume(shipmentMethod, item);

  return Math.max(1.5 * v, 8.4);
};

export const calcTotalGovFees = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcTotalGovFees(shipmentMethod, x)).reduce((a, b) => a + b, 0);
  if (shipmentMethod === "air") return 0;
  if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  return calcInsurance(shipmentMethod, item) + calcPortFee(shipmentMethod, item);
};

const TypeCost = {
  package: 2.5,
  pallet: 15,
};

export const calcMiaWarehouseFee = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcMiaWarehouseFee(shipmentMethod, x)).reduce((a, b) => a + b, 0);
  if (shipmentMethod === "ocean" && !item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  if (shipmentMethod === "air" && !item.invoiceTotal && !item.weight) return 0;
  return item.count * TypeCost[item.type];
};

export const calcBrokerFee = (shipmentMethod, item) => {
  if (shipmentMethod === "air") {
    if (Array.isArray(item)) {
      const total = item.map((x) => x.weight).reduce((a, b) => a + b, 0);
      if (total >= 5 && total < 10) return 25;
      return total >= 10 ? 50 : 0;
    }
    if (item.weight >= 5) return 25;
    if (item.weight >= 10) {
      return 50;
    }
    return 0;
  }

  if (Array.isArray(item)) {
    // Nothing needed
  } else if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  const c = calcTotalGovFees(shipmentMethod, item) + calcFreightCarge(shipmentMethod, item);

  const volume = calcVolume(shipmentMethod, item);
  if (volume < 1) return 0;
  if (volume >= 1 && volume <= 1.99) return 25;
  // if (calcVolume(shipmentMethod, item) < 2) return 0;
  if (c < 1000) return 50;
  if (c < 5000) return 75;

  return 100;
};

export const calcCustomsFee = (shipmentMethod, item) => {
  if (Array.isArray(item)) return item.map((x) => calcCustomsFee(shipmentMethod, x)).reduce((a, b) => a + b, 0);
  if (shipmentMethod === "ocean" && !item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;
  if (shipmentMethod === "air" && !item.invoiceTotal && !item.weight) return 0;

  return (item.invoiceTotal + calcFreightCarge(shipmentMethod, item)) * 0.22;
};

export const calcTotalFees = (shipmentMethod, item) => {
  if (Array.isArray(item)) {
    return item.map((x) => calcTotalFees(shipmentMethod, x)).reduce((a, b) => a + b, 0) + calcBrokerFee(shipmentMethod, item) + calcInsurance(shipmentMethod, item) + calcPortFee(shipmentMethod, item);
  }
  if (!item.invoiceTotal && !item.height && !item.width && !item.depth) return 0;

  return (
    calcFreightCarge(shipmentMethod, item) +
    // calcTotalGovFees(shipmentMethod, item) +
    calcMiaWarehouseFee(shipmentMethod, item) +
    calcCustomsFee(shipmentMethod, item)
    // calcBrokerFee(shipmentMethod, item)
  );
};

const formatter = Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  style: "currency",
  currency: "USD",
});
export const formatCost = (cost) => {
  return formatter.format(cost);
};
